import React from 'react';

import { ReactComponent as Logo } from 'assets/logo.svg';

import { SECTIONS } from 'constants/sections';

import Section from 'components/Section';

import './styles.scss';

function Home() {
  return (
    <Section name={SECTIONS.HOME.name}>
      <div className="logo-container">
        <Logo />
      </div>
      <div className="title-section">
        <h1 className="title">Enrique Mejía</h1>
        <span className="subtitle">Human & Web Developer</span>
      </div>
    </Section>
  )
}

export default Home;
